"use client";

import { cn } from "utils";

function SkeletonBlock({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-content_inverse_primary/10",
        className,
      )}
    />
  );
}

function FindingCardSkeleton() {
  return (
    <div
      className="flex w-full flex-col overflow-hidden rounded-lg"
      data-testid="diagnosis-unlock-step2-finding-skeleton"
    >
      <div className="flex h-7 w-full shrink-0 items-center gap-1 bg-content_aura_lv3_primary px-3 py-1">
        <SkeletonBlock className="size-4 shrink-0 rounded-sm bg-content_inverse_tertiary" />
        <SkeletonBlock className="h-4 w-24 bg-content_inverse_tertiary" />
      </div>
      <div className="flex flex-col gap-2 rounded-lg bg-background_clearcover p-3 backdrop-blur-[10px]">
        <SkeletonBlock className="h-5 w-[72%] bg-content_inverse_tertiary" />
        <SkeletonBlock className="h-4 w-full bg-content_inverse_tertiary" />
        <SkeletonBlock className="h-4 w-[88%] bg-content_inverse_tertiary" />
      </div>
    </div>
  );
}

/** Step2 诊断区骨架 — 1 句 headline + 3 条 finding 卡占位 */
export function DiagnosisUnlockDiagnosisStepSkeleton({
  className,
}: {
  className?: string;
}) {
  return (
    <div
      className={cn("flex w-full flex-col gap-10", className)}
      data-testid="diagnosis-unlock-step2-skeleton"
      aria-busy="true"
      aria-label="Loading diagnosis report"
    >
      <div
        className="flex w-full flex-col items-center gap-3"
        data-testid="diagnosis-unlock-step2-headline-skeleton"
      >
        <div className="h-8 w-[92%] max-w-[320px] animate-pulse rounded-md bg-content_inverse_tertiary" />
        <div className="h-8 w-[72%] max-w-[260px] animate-pulse rounded-md bg-content_inverse_tertiary" />
      </div>
      <div className="flex w-full flex-col gap-3">
        <FindingCardSkeleton />
        <FindingCardSkeleton />
        <FindingCardSkeleton />
      </div>
    </div>
  );
}
